import React from "react";

const services = [
	"Facility Maintenance & Cleaning",
	"IT Infrastructure Deployment",
	"Power Backup Systems",
	"Server & Cloud Solutions",
	"Preventive Support Services",
];

const Services = () => (
	<section className="py-16 bg-gray-50" id="services">
		<div className="max-w-6xl mx-auto px-4">
			<h3 className="text-4xl font-bold mb-6 text-[#ff7200]">Our Services</h3>
			<div className="grid md:grid-cols-2 gap-6 text-[#4e4e4e]">
				{services.map((service, index) => (
					<div
						key={index}
						className="bg-white p-5 rounded-lg border-l-4 border-[#ff7200] shadow hover:shadow-md transition"
					>
						<h4 className="font-semibold text-lg">{service}</h4>
					</div>
				))}
			</div>
		</div>
	</section>
);

export default Services;
